export const CHAIN_IDS = {
    BASE: 8453,
    HYPEREVM: 999,
    ROBINHOOD: 4663,
    ROBINHOOD_L2: 46630,
};
export const SUPPORTED_CHAIN_IDS = [
    CHAIN_IDS.BASE,
    CHAIN_IDS.HYPEREVM,
    CHAIN_IDS.ROBINHOOD,
    CHAIN_IDS.ROBINHOOD_L2,
];
export function isSupportedChainId(value) {
    return SUPPORTED_CHAIN_IDS.includes(value);
}
export const PROPOSAL_STATES = [
    "Draft",
    "Pending",
    "GuardianReview",
    "Approved",
    "Rejected",
    "Cancelled",
    "Vetoed",
    "Executed",
    "Settled",
];
